import { CheckoutUserFlowEnum } from 'components/views/pages/Checkout/types';

export const generateCheckoutUserFlowDialogTitle = (checkoutStep: CheckoutUserFlowEnum) => {
  switch (checkoutStep) {
    case CheckoutUserFlowEnum.Login: {
      return 'Login';
    }

    case CheckoutUserFlowEnum.ForgotPassword: {
      return 'Forgot Password';
    }

    case CheckoutUserFlowEnum.CreateAccount: {
      return 'Create Account';
    }

    default: {
      return 'Unknown step';
    }
  }
};

export const generateCheckoutUserFlowBackAction = (
  checkoutStep: CheckoutUserFlowEnum,
): CheckoutUserFlowEnum | undefined => {
  switch (checkoutStep) {
    case CheckoutUserFlowEnum.Login: {
      return undefined;
    }

    case CheckoutUserFlowEnum.ForgotPassword: {
      return CheckoutUserFlowEnum.Login;
    }

    case CheckoutUserFlowEnum.CreateAccount: {
      return undefined;
    }

    default: {
      return undefined;
    }
  }
};
